import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';

import { isClean, isExplicit } from '../../../utils';

import AlbumGridItem from './AlbumGridItem';

const AlbumGridItemWrapper = props => {
  const { album } = props;
  const pandoraId = get(album, 'pandoraId', '');
  const releaseYear = new Date(get(album, 'releaseDate', '')).getUTCFullYear().toString();

  const albumArtistId = get(album, 'artistId.pandoraId', '');
  const isCollaboration = albumArtistId !== props.artistPandoraId;
  return (
    <AlbumGridItem
      albumBackstagePath={get(album, 'shareableUrlPath', '')}
      albumTitle={get(album, 'name', '')}
      artUrl={get(album, 'icon.artUrl', '')}
      collaborationName={isCollaboration && get(album, 'artistName.name', '')}
      collaborationUrl={isCollaboration && get(album, 'artist.url', '')}
      isClean={isClean(album)}
      isDisabled={props.isDisabled}
      isExplicit={isExplicit(album)}
      isFluid={props.isFluid}
      isRadioOnly={
        !get(album, 'rightsInfo.hasInteractive', true) &&
        get(album, 'rightsInfo.hasRadioRights', false)
      }
      isUnavailable={
        !get(album, 'rightsInfo.hasInteractive', true) &&
        !get(album, 'rightsInfo.hasRadioRights', false)
      }
      pandoraId={pandoraId}
      trackCount={get(album, 'trackCount', 0)}
      twoColumns={props.twoColumns}
      year={releaseYear}
    />
  );
};

AlbumGridItemWrapper.propTypes = {
  album: PropTypes.object,
  artistPandoraId: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFluid: PropTypes.bool,
  twoColumns: PropTypes.bool,
};

export default AlbumGridItemWrapper;
